import React, { useEffect, useState } from 'react'
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useNavigate, useParams } from "react-router-dom";
import ToastrService from "../../services/toastService";
import Loader from "../loader/loader"
import { useGetUserEmailMutation, useResetPasswordMutation } from './Api';
import logo from '../../assets/images/logoicon.ico'
import { FaEye, FaEyeSlash } from "react-icons/fa";

const ResetPassword = () => {

    const navigate = useNavigate()

    const [password, setPassword] = useState(true);
    const passwordChangeIcon = password === true ? false : true;

    const [confirmPassword, setConfirmPassword] = useState(true);
    const confirmPasswordChangeIcon = confirmPassword === true ? false : true;


    const [getUserEmailApi, { isLoading: getEmailLoading }] = useGetUserEmailMutation()
    const [resetPasswordApi, { isLoading }] = useResetPasswordMutation()

    const [flow, setFlow] = useState()


    const { token } = useParams()

    useEffect(() => {

        const fetchEmail = async () => {
            if (token) {
                const response = await getUserEmailApi({ link: token });
                if (response?.data?.success) {
                    reset({ email: response.data.data.email })
                    setFlow(response.data.data.flow)
                } else {
                    navigate('/')
                    ToastrService.error("Link expired");
                }
            }
        };

        fetchEmail();
    }, []);


    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .required('Email is required')
            .matches(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                "Enter valid Email")
            .email('Email is invalid')
            .trim(),
        password: Yup.string()
            .required('Password is required')
            .min(8, 'Password must be at least 8 characters')
            .matches(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                "Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character"
            )
            .trim(),
        confirmPassword: Yup.string()
            .required('Confirm Password is required')
            .oneOf([Yup.ref('password'), null], 'Passwords must match'),
    });

    const { register, handleSubmit, reset, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'all'
    });


    // dark mode
    useEffect(() => {
        const theme = localStorage.getItem('theme')
        if (theme === 'dark') {
            const darkMode = true
            document.documentElement.classList.toggle("app-skin-dark", darkMode);
        }
    }, []);

    const onSubmit = async (data) => {
        try {
            const payload = {
                link: token,
                password: data.password
            }

            const resetPasswordRes = await resetPasswordApi(payload)

            if (resetPasswordRes?.data?.success) {
                if (flow == "Set") {
                    ToastrService.success("Your password has been set successfully.Your acccount is now active");
                } else {
                    ToastrService.success(resetPasswordRes?.data?.message);
                }
                reset()
                navigate('/')

            } else {
                ToastrService.error(resetPasswordRes.error.data.message);
            }
        } catch (err) {
            console.log(err, 'err')
        }
    };

    return (
        <div>
            {isLoading || getEmailLoading ? <Loader /> :
                <div className="auth-minimal-wrapper">
                    <div className="auth-minimal-inner">
                        <div className="minimal-card-wrapper">
                            <div className="card mb-4 mt-5 mx-4 mx-sm-0 position-relative">
                                <div class="wd-50 bg-white p-2 rounded-circle shadow-lg position-absolute translate-middle top-0 start-50">
                                    <img src={logo} alt="" class="img-fluid" />
                                </div>
                                <div className="card-body p-sm-5">
                                    <h2 className="fs-20 fw-bolder mb-4">{flow === "Set" ? "Set Your Password" : "Reset Password"}</h2>
                                    <form onSubmit={handleSubmit(onSubmit)} className="w-100 mt-4 pt-2">
                                        <div className="mb-4">
                                            <input
                                                type="text"
                                                id="mail"
                                                name='email'
                                                placeholder='Email'
                                                readOnly
                                                {...register('email')}
                                                className="form-control"
                                            />
                                            {errors.email && (
                                                <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                                    {errors.email.message}
                                                </p>
                                            )}
                                        </div>

                                        <div className="mb-4">
                                            <div className="password-field">
                                                <input
                                                    type={passwordChangeIcon ? "text" : "password"}
                                                    {...register("password")}
                                                    className="form-control"
                                                    placeholder="Password"
                                                />
                                                <span
                                                    className="password-icon"
                                                    onClick={() => setPassword(!password)}
                                                >
                                                    {passwordChangeIcon ? <FaEye /> : <FaEyeSlash />}
                                                </span>
                                            </div>
                                            {errors.password && (
                                                <p className='mt-2' style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                                    {errors.password.message}
                                                </p>
                                            )}
                                        </div>

                                        <div className="mb-4">
                                            <div className="password-field">
                                                <input
                                                    type={confirmPasswordChangeIcon ? "text" : "password"}
                                                    {...register("confirmPassword")}
                                                    className="form-control"
                                                    placeholder="Confirm Password"
                                                />
                                                <span
                                                    className="password-icon"
                                                    onClick={() => setConfirmPassword(!confirmPassword)}
                                                >
                                                    {confirmPasswordChangeIcon ? <FaEye /> : <FaEyeSlash />}
                                                </span>
                                            </div>
                                            {errors.confirmPassword && (
                                                <p className='mt-2' style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                                    {errors.confirmPassword.message}
                                                </p>
                                            )}
                                        </div>
                                        <div className="mt-5">
                                            <button type="submit" className="btn btn-lg btn-primary w-100">
                                                Submit
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default ResetPassword
